module.exports = __webpack_public_path__ + "img/diapositiva-2-1.dbafb078.png";